<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    item-text="title"
    :items="subjectGroups"
    item-value="id"
    @change="onChange"
    v-on:input="$emit('input', $event)"
    @update:search-input="update"
    :loading="loading"
    clearable
  ></v-autocomplete>
</template>

<script>
import { SubjectGroup, Teaching } from '@/plugins/api'
import { mapState } from 'vuex'
import { uniqBy, sortBy } from 'lodash'

export default {
  data: () => ({
    subjectGroups: [],
    loading: false,
  }),
  props: {
    filter: Object,
    defaultSubjectGroups: Array,
    options: Object,
  },
  computed: {
    ...mapState('auth', ['role', 'profile']),
  },
  async created() {
    if (this.defaultSubjectGroups) {
      this.subjectGroups = this.defaultSubjectGroups
    }
    if (this.role.type === 'teacher') {
      const teachings = await Teaching.fetch({ teacher: this.profile.id, _limit: -1 })
      this.subjectGroups = sortBy(
        uniqBy(
          teachings.map(x => x.subjectGroup),
          x => x.id
        ),
        x => x.index
      )
    } else this.fetchAllSubjectGroups()
  },
  methods: {
    async fetchAllSubjectGroups() {
      this.loading = true
      this.subjectGroups = await SubjectGroup.fetch({
        ...this.filter,
        _limit: -1,
        _sort: 'index:ASC',
      })
      this.loading = false
    },
    async update(data) {},
    onChange(data) {
      this.$emit('change', data)
    },
  },
  watch: {
    filter(filter) {
      this.fetchAllSubjectGroups()
    },
  },
}
</script>

<style scoped></style>
